import React from 'react';
import { Card, Typography, Space, Tag } from 'antd';
import { LikeOutlined, MessageOutlined, PushpinFilled, EyeOutlined } from '@ant-design/icons';
import { Link, useLocation } from 'react-router-dom';
import styles from './PostCard.module.scss';
import { pages } from '../../constants/PagePaths';

const { Text } = Typography;

interface PostCardProps {
  id: number;
  title: string;
  author: string;
  date: string;
  likes: number;
  comments: number;
  views: number;
  category: number;
  isPinned?: boolean;
}

const PostCard: React.FC<PostCardProps> = ({ 
  id, title, author, date, likes, comments, views, category, isPinned = false
}) => {
  const location = useLocation();

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}`;
  };

  // 현재 쿼리 파라미터를 returnUrl로 인코딩
  const getDetailUrl = () => {
    const baseUrl = `${pages.community}/${category}/${id}`;
    if (location.search) {
      const returnUrl = encodeURIComponent(`${location.pathname}${location.search}`);
      return `${baseUrl}?returnUrl=${returnUrl}`;
    }
    return baseUrl;
  };

  return (
    <Card 
      className={`${styles.postCard} ${isPinned ? styles.pinnedCard : ''}`} 
      hoverable
    >
      <Link to={getDetailUrl()} className={styles.cardLink}>
        <div className={styles.postContent}>
          <div className={styles.titleContainer}>
            {isPinned && (
              <Tag 
                icon={<PushpinFilled />} 
                color="volcano" 
                className={styles.pinnedTag}
              >
                공지
              </Tag>
            )}
            <Text className={`${styles.postTitle} ${isPinned ? styles.pinnedTitle : ''}`}>
              {title}
            </Text>
          </div>
          <div className={styles.postInfo}>
            <div className={styles.authorDateContainer}>
              <Text type="secondary" className={styles.author}>{author}</Text>
              <Text type="secondary" className={styles.date}>{formatDate(date)}</Text>
            </div>
            <div className={styles.postStats}>
              <span className={styles.iconWrapper}>
                <LikeOutlined className={styles.likeIcon} /> {likes}
              </span>
              <span className={styles.iconWrapper}>
                <MessageOutlined className={styles.commentIcon} /> {comments}
              </span>
              <span className={styles.iconWrapper}>
                <EyeOutlined className={styles.viewIcon} /> {views}
              </span>
            </div>
          </div>
        </div>
      </Link>
    </Card>
  );
};

export default PostCard;
